import KpiAssistance from './KpiAssistance';
export default KpiAssistance;
